const initstate = {
  orderListInfoData: {},
  orderListDetailInfoData: [],
  isShowLogisticHistoriesModal: false,
  selectLogisticHistories: {},
  isShowOrderQuestionModal: false,
  selectOrderQuestion: {},
  orderListAdv: {},
};

export function orderListState(state = initstate, action) {
  switch (action.type) {
    case "GET_ORDER_LIST_DATA": {
      return {
        ...state,
        orderListInfoData: action.payload,
      };
    }
    case "GET_ORDER_LIST_DETAIL_DATA": {
      const { orderListDetailResponse, index } = action.payload;
      const previousOrderDetail = [...state.orderListDetailInfoData];
      previousOrderDetail[index] = orderListDetailResponse;
      return {
        ...state,
        orderListDetailInfoData: previousOrderDetail,
      };
    }
    case "GET_ORDER_LIST_ADVERTISEMENT": {
      return {
        ...state,
        orderListAdv: action.payload,
      };
    }
    case "SHOW_ORDER_LIST_LOGISTIC_HISTORIES_MODAL": {
      return {
        ...state,
        isShowLogisticHistoriesModal: true,
      };
    }
    case "CLOSE_ORDER_LIST_LOGISTIC_HISTORIES_MODAL": {
      return {
        ...state,
        isShowLogisticHistoriesModal: false,
      };
    }
    case "UPDATE_ORDER_LIST_LOGISTIC_HISTORIES": {
      const { logisticHistories, consignmentCode, isLargeFurniture } =
        action.payload;
      // logisticHistoriesTitle手機版大型傢具/家電類型物流歷史紀錄彈出視窗要顯示特定文字
      return {
        ...state,
        selectLogisticHistories: {
          isLargeFurniture: isLargeFurniture,
          logisticHistories: logisticHistories,
          consignmentCode: consignmentCode,
        },
      };
    }
    case "SHOW_ORDER_LIST_QUESTIONS_MODAL": {
      return {
        ...state,
        isShowOrderQuestionModal: true,
      };
    }
    case "CLOSE_ORDER_LIST_QUESTIONS_MODAL": {
      return {
        ...state,
        isShowOrderQuestionModal: false,
      };
    }
    case "UPDATE_ORDER_LIST_QUESTIONS": {
      const { orderListDetail, ordercode } = action.payload;

      let selectOrderQuestion = {
        ordercode: "",
        questionList: [],
      };

      selectOrderQuestion.questionList = orderListDetail.map((item) => {
        return {
          productCode: item.productCode,
          productName: item.productName,
        };
      });
      selectOrderQuestion.ordercode = ordercode;
      return {
        ...state,
        selectOrderQuestion: selectOrderQuestion,
      };
    }
    case "UPDATE_ORDER_LIST_TAX_ID": {
      const { buyerUnifiedCode, orderItemIndex } = action.payload;
      state.orderListInfoData.orders[orderItemIndex].buyerUnifiedCode =buyerUnifiedCode;
      return {
        ...state,
        orderListInfoData: state.orderListInfoData,
      };
    }
    default:
      return state;
  }
}

export default orderListState;
